export const VIEWED_ONBOARDING = 'viewed_onboarding'
export const STARTED_ONBOARDING = 'started_onboarding'
export const SELECTED_DAILY_EMAIL_TIME = 'selected_daily_email_time'
export const SELECTED_STORE_TYPE = 'selected_store_type'
export const UNSELECTED_STORE_TYPE = 'unselected_store_type'
export const ENTERED_PHONE_NUMBER = 'entered_phone_number'
export const CLICKED_COMPLETE_ONBOARDING = 'clicked_complete_onboarding'
export const CLICKED_SKIP = 'clicked_skip'
export const CLICKED_CLOSE_DIALOG = 'clicked_close_dialog'
export const VIEWED_INFORMATIONAL_SNACKBAR = 'viewed_informational_snackbar'
export const CLICKED_NEXT = 'clicked_next'
